<template>
  <div class="login">
    Authenticating
    <div class="loader"></div>
  </div>
</template>

<script>
import Config from '@/config';
import { mapGetters } from 'vuex';

export default {
  name: 'Login',

  computed: {
    ...mapGetters(['isLogged']),
  },

  mounted() {
    if (!this.isLogged) {
      window.location.replace(Config.LOGIN_URL);
    } else {
      this.$store
        .dispatch('updateUserInfo')
        .then(() => {
          this.$router.push({ name: 'studyList' });
        })
        .catch(() => {
          window.location.replace(Config.LOGIN_URL);
        });
    }
  },
};
</script>

<style scoped lang="scss">
.login {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 48px;
}
</style>
